// Floating damage number. Non-blocking (goes on flourish track).

import type { Animation } from "../../engine/animation/AnimationQueue";
import { Easing } from "../../engine/animation/Easing";
import { TIMING } from "../../config/constants";

export class DamagePopup implements Animation {
  private elapsed = 0;
  private duration = TIMING.damagePopupDuration;
  private offsetX = (Math.random() - 0.5) * 14;

  constructor(
    private startX: number,
    private startY: number,
    private amount: number,
    private color: string = "#e8e4d6",
    private label?: string,
  ) {}

  update(dt: number): void {
    this.elapsed = Math.min(this.elapsed + dt, this.duration);
  }

  draw(ctx: CanvasRenderingContext2D): void {
    const p = this.elapsed / this.duration;
    const riseEased = Easing.easeOutCubic(p);
    const y = this.startY - 40 * riseEased;
    const x = this.startX + this.offsetX;
    const alpha = p < 0.7 ? 1 : Math.max(0, 1 - (p - 0.7) / 0.3);
    const scale = 0.9 + Easing.easeOutBack(Math.min(1, p * 3)) * 0.3;

    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.translate(x, y);
    ctx.scale(scale, scale);
    const fontSize = this.label ? 20 : Math.round(Math.max(16, Math.min(38, 14 + Math.sqrt(this.amount) * 1.6)));
    ctx.font = `bold ${fontSize}px 'Inter', sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.lineWidth = 3;
    ctx.strokeStyle = "#000";
    const text = this.label ?? (this.amount > 0 ? String(this.amount) : "");
    if (!text) { ctx.restore(); return; }
    ctx.strokeText(text, 0, 0);
    ctx.fillStyle = this.color;
    ctx.fillText(text, 0, 0);
    ctx.restore();
  }

  isDone(): boolean {
    return this.elapsed >= this.duration;
  }
}
